import './src/styles/global.css';
import React from 'react';
import { SnackbarProvider } from 'notistack';
import NotificationProvider from './src/components/root/notification';
// import { DndProvider } from 'react-dnd';
// import { HTML5Backend } from 'react-dnd-html5-backend';
import { THEME_GREEN, THEME_DARK_YELLOW, THEME_YELLOW } from './src/constants/style';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { MemberContextProvider } from './src/components/profile-page/member-context';
import { DialogsProvider } from '@toolpad/core/useDialogs';
import { ErrorBoundaryWrapper } from './src/components/error/error-boundary';

export const wrapRootElement = ({ element }) => {
  const theme = createTheme({
    palette: {
      primary: {
        main: THEME_GREEN,
      },
      warning: {
        main: THEME_YELLOW,
        dark: THEME_DARK_YELLOW,
      },
    },
    typography: {
      button: {
        textTransform: 'none'
      }
    }
  });

  return (
    <ErrorBoundaryWrapper >
      <MemberContextProvider>
        <SnackbarProvider>
          <NotificationProvider>
            <ThemeProvider theme={theme}>
              <DialogsProvider>
                {/* <DndProvider backend={HTML5Backend}> */}
                {element}
                {/* </DndProvider> */}
              </DialogsProvider>
            </ThemeProvider>
          </NotificationProvider>
        </SnackbarProvider>
      </MemberContextProvider>
    </ErrorBoundaryWrapper>
  );
};